export const NF_TEST = 'narrow-framing';
export const RR_TEST = 'retirement-regret';
export const LA_TEST = 'loss-aversion';



// WEBPACK FOOTER //
// ./src/constants.js